<template>
  <div>
    Copyright © {{year}} Superchain. All rights reserved.
  </div>
</template>

<script>
export default {
  data() {
    return {
      year: ''
    }
  },
  mounted() {
    const date = new Date()
    this.year = date.getFullYear()
  }
}
</script>

<style lang="scss" scoped>
</style>